import React from 'react'
import restaurantData from './hotelData'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NavLink } from 'react-router-dom'
import './AllCollection.css'

const AllCollection = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="heading-collection">
                        <h2 className="title-collection pt-4 mb-0">
                            Collection -Ahmedabad
                        </h2>
                        <p className='sub-title mt-1'>Create and browse list of the finest restuarents</p>
                    </div>
                    <div className="links-collection d-flex align-center mt-4 ml-4">
                        <NavLink to="/collections" className='collection-pages m-3 ' activeClassName="active">Handpicked</NavLink>
                        <NavLink to="/collection-saved" className='collection-pages m-3' activeClassName="active">Saved Collections</NavLink>

                    </div>
                    <hr className='hr-collection h-10px' />
                    {restaurantData.map((collection) =>
                        <div className="cards__collection col-lg-3 col-md-3">
                            <div className="cards mt-3">
                                <img src={collection.img} alt="" />
                                <div className="card-content">
                                    <h3 className='font-bold title'>{collection.maintitle}</h3>
                                    <p className='places-collection'>{collection.rating} rating</p>
                                </div>
                            </div>

                        </div>)}
                </div>
            </div>

        </>
    )
}

export default AllCollection